<template>
    <h2 class="hidden md:block mb-1 text-3xl font-bold">Impostazioni</h2>
    <div class="md:hidden  text-gray-800 mt-4 sm:-mt-1 -mb-4 mx-auto text-md ">
        <div class="">
            Impostazioni
        </div>
    </div>
</template>